export class DuplicateDepartmentName extends Error {
  constructor() {
    super('This name already exists in this court system.')
    Object.setPrototypeOf(this, DuplicateDepartmentName.prototype)
  }
}
